import React, { Component } from 'react';
import { widgetConfiguration, IWidgetData, stylesWidgetContainer } from '../../helpers/quinn-ctas';
import CustomEsmWidget from './CustomEsmWidget';
import { QSWidgetClassNames, QSWidgetTypes } from '../../helpers/interfaces';

interface QSWidgetProps {
  qsWidget: QSWidgetTypes;
  className?: QSWidgetClassNames;
  postData: {
    id: string;
    catSlug: string;
    catId: string;
    isSEMtemplate: boolean;
  };
}

interface QSWidgetTypestate {
  // src: string;
  isLoaded: boolean;
}

class QSWidget extends Component<QSWidgetProps, QSWidgetTypestate> {
  private widget = widgetConfiguration[this.props.qsWidget];
  private inventoryTypeMapping: Record<
    string,
    { src: string; inventoryType: string; exclude: string[] | null }
  > = {
    highyield: { src: '691523', inventoryType: 'valueprops-incontent', exclude: ['53819'] },
    checking: { src: '691804', inventoryType: 'valueprops-incontent', exclude: null },
    cd: { src: '691806', inventoryType: 'valueprops3_cd-incontent', exclude: ['62547'] },
    mma: { src: '693643', inventoryType: 'valueprops-incontent', exclude: ['61952'] }
  };

  constructor(props: QSWidgetProps) {
    super(props);
    this.state = {
      // src: widgetConfiguration[props.qsWidget].src({}),
      // conf: '',
      // cat: this.props.postData.catSlug || '',
      // mkid: '00000000-0000-0000-0000-000000000000',
      isLoaded: false
    };
  }

  componentDidMount() {
    if (typeof window !== 'undefined' && this.props.qsWidget && this.widget) {
      this.checkShAvailability();
    }
  }

  checkShAvailability = () => {
    let counter = 0;
    const intervalId = setInterval(() => {
      if (window.sh && typeof window.sh.initialize === 'function' && window.ECS?.tms?.data) {
        clearInterval(intervalId);
        this.initializeWidget();
      } else if (counter > 15) {
        clearInterval(intervalId);
      }
      counter++;
    }, 100);
  };

  updateWidgetConf = (): string => {
    const { isSEMtemplate } = this.props.postData;
    const type = this.props.qsWidget;
    const removeStyles = () => {
      if (type === 'cd' || isSEMtemplate) {
        return '';
      }
      if (type === 'checking' || type === 'annuity') {
        // Remove padding from the widget
        return `#${this.widget.widgetContainerId} div { padding: 0; }`;
      }
      // Add margin auto to widget container div to center for xl screens
      if (type === 'pet_insurance') {
        return `${this.widget.styles} #${this.widget.widgetContainerId} div { margin: auto; }`;
      }
      return this.widget.styles;
    };

    return isSEMtemplate ? removeStyles() : this.widget.styles;
  };

  getCookie = (name: string) => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop()?.split(';').shift();
    return '';
  };

  initializeWidget = () => {
    this.widget.styles = this.updateWidgetConf();
    const queryParams = this.getQueryParams();
    const mkid =
      queryParams.mkid || this.getCookie('marketingid') || '00000000-0000-0000-0000-000000000000';
    const params = {
      ...queryParams,
      pc: window.ECS?.tms?.data.pc,
      cc: window.ECS?.tms?.data.cc,
      mkid: mkid
    };
    const { postData } = this.props;
    const v2 = {
      id: postData.id ? `id:${postData.id}` : '',
      cat: postData.catSlug ? `|cat:${postData.catSlug}` : '',
      pc: params.pc ? `|pc:${params.pc}` : '',
      cc: params.cc ? `|cc:${params.cc}` : '',
      conf: params.conf ? `|conf:${params.conf}` : '',
      mkid: params.mkid ? `|mkid:${params.mkid}` : ''
    };
    const src = this.widget.src(params);
    const type = this.props.qsWidget;
    let inventoryType = this.widget.config.inventorytype;
    if (
      this.inventoryTypeMapping[type]?.src === src &&
      (!this.inventoryTypeMapping[type].exclude ||
        !this.inventoryTypeMapping[type].exclude?.includes(this.props.postData.id))
    ) {
      inventoryType = this.inventoryTypeMapping[type].inventoryType;
    }
    const matchingConfiguration = {
      ...this.widget.config,
      src: src,
      var2: `${v2.id}${v2.cat}${v2.pc}${v2.cc}${v2.conf}${v2.mkid}`,
      inventorytype: inventoryType
    };
    window.sh.initialize(matchingConfiguration, this.widget.widgetContainerId);
    this.setState({ isLoaded: true });
  };

  getQueryParams = () => {
    const params = new URLSearchParams(window.location.search);
    return {
      conf: params.get('conf') || '',
      mkid: params.get('mkid') || '',
      st: params.get('st') || ''
    };
  };

  renderCustomWidget = (type: QSWidgetTypes) => {
    const { isSEMtemplate } = this.props.postData;

    if (type === 'checking' && !isSEMtemplate) {
      return <CustomEsmWidget isSEMtemplate={isSEMtemplate} />;
    }

    return null;
  };

  toShowBgTitlesVersion = (widget: IWidgetData) => {
    const { isSEMtemplate, catSlug } = this.props.postData;
    const { className } = this.props;
    let toShowBgTitlesVersion: boolean = !!(widget.brow && widget.title);

    if (isSEMtemplate || catSlug === 'lp') {
      toShowBgTitlesVersion = false;
    }
    if (className === 'qs-widget-background') {
      toShowBgTitlesVersion = true;
    }
    if (toShowBgTitlesVersion && className === 'qs-widget-no-background') {
      toShowBgTitlesVersion = false;
    }
    return toShowBgTitlesVersion;
  };

  render() {
    if (!this.widget) return null;
    const toShowBgTitles = this.toShowBgTitlesVersion(this.widget);
    const styles =
      this.props.className === 'qs-widget-no-background'
        ? `${this.widget.styles} ${stylesWidgetContainer}`
        : this.widget.styles;

    return (
      <div
        {...(this.widget.mainId && { id: this.widget.mainId })}
        className={`${toShowBgTitles ? 'bg-light p-3 p-lg-4 rounded-3 mt-6' : 'mt-4 mt-lg-5'} mb-4`}>
        {this.state.isLoaded ? (
          <>
            <style>{styles}</style>
            {toShowBgTitles && <p className="eyebrow-text text-gray mb-0">{this.widget.brow}</p>}
            {toShowBgTitles && <h2 className="heading-mb">{this.widget.title}</h2>}
          </>
        ) : null}

        {this.renderCustomWidget(this.props.qsWidget)}
        <div id={this.widget.widgetContainerId} />
      </div>
    );
  }
}

export default QSWidget;
